import type { EmployeeOrdersResponse } from '../types';

export async function fetchEmployeeOrders(): Promise<EmployeeOrdersResponse> {
  const res = await fetch('/api/employee-orders');
  if (!res.ok) {
    throw new Error('Failed to fetch employee orders');
  }
  return res.json();
}
